import React from 'react';

import { CardListFilterMenuButton } from '@vlabs/monokit/entities/cards/filters/CardListFilterMenuButton';
import { useCardsFilters } from '@vlabs/monokit/entities/cards/filters/useCardsFilters';
import { CreateCardButton } from '@vlabs/monokit/features/create-card';
import { usePageContext } from '@vlabs/monokit/shared/ui/page';
import { useTranslation } from 'react-i18next';

export function ListCardsActions(): React.JSX.Element {
  const { t } = useTranslation();
  const pageCtx = usePageContext();
  const { filters } = useCardsFilters();

  return (
    <React.Fragment>
      <CreateCardButton
        defaultValues={{
          lists: filters.list_ids,
        }}
        size={pageCtx.buttonSize}
      >
        {t('list-details-page:list_cards_actions.create_card_label')}
      </CreateCardButton>
      <CardListFilterMenuButton exclude={['list_ids']} />
    </React.Fragment>
  );
}
